import { Injectable } from '@angular/core';
import { 
  CanActivate, 
  CanActivateChild, 
  Router, 
  ActivatedRouteSnapshot, 
  RouterStateSnapshot 
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkAuth(state.url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(route, state);
  }

  private checkAuth(url: string): boolean {
    console.log('Auth guard checking access to:', url);
    
    // Skip check for auth routes
    if (url.includes('/auth/')) {
      return true;
    }
    
    // Check if there's a token in localStorage
    const token = localStorage.getItem('userToken');
    
    if (token) {
      console.log('Token found, allowing access to:', url);
      return true;
    }

    // Don't redirect if already on login page
    if (url === '/auth/sign-in') {
      return true;
    }

    // Store the attempted URL for redirecting after login
    console.log('Auth guard storing redirect URL:', url);
    sessionStorage.setItem('redirectAfterLogin', url);

    // Show notification
    this.snackBar.open('Please login to continue', 'Close', {
      duration: 3000,
      panelClass: ['info-snackbar']
    });

    // Navigate to the login page
    this.router.navigate(['/auth/sign-in']);
    return false;
  }
} 